.page {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
}

.comingSoon {
	border-radius: var(--radius-lg);
	background-color: light-dark(var(--gray-400), var(--gray-800));
	font-weight: 500;
	padding: var(--size-5);
}

.comingSoonHeader {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	margin-bottom: var(--size-4);
}

.comingSoonNote {
	color: var(--color-text-subtle);
	font-weight: 400;
}

.chart {
	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-rows: 200px auto;
	gap: var(--size-1) var(--size-2);
	padding: var(--size-5);
}

.yAxis {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	text-align: right;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.bars {
	display: flex;
}

.xAxis {
	grid-column: 2;
	display: flex;
}

.xLabel {
	flex: 1;
	text-align: center;
	white-space: nowrap;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.bar {
	display: flex;
	flex-direction: column-reverse;
	flex: 1;
	padding: 0 var(--size-1);

	&:hover,
	&:focus-visible {
		background-color: var(--color-border);
	}
}

.stack {
	display: flex;
	flex-direction: column-reverse;
	height: calc(100% * var(--total) / var(--max));
	border-top-left-radius: var(--radius-sm);
	border-top-right-radius: var(--radius-sm);
	overflow: clip;
}

.chunk {
	flex-grow: var(--hours);
	flex-basis: 0;
	background-color: var(--fill);
}

.legend {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: var(--size-2) var(--size-5);
	padding: 0 var(--size-5) var(--size-5);
}

.empty {
	text-align: center;
	padding: var(--size-8);
}

.legendLabel {
	font-weight: 600;
}

.tooltipDate {
	font-weight: 600;
	margin-bottom: var(--size-1);
}

.orgRow {
	display: flex;
	align-items: center;
	gap: var(--size-2);

	&::before {
		content: "";
		display: block;
		width: var(--size-3);
		height: var(--size-3);
		background-color: var(--color);
		border-radius: var(--radius-xs);
	}
}

.invoiceStatus {
	text-transform: capitalize;
}
